import { Component, EventEmitter, Input, OnChanges, OnInit, Output, ViewChild } from '@angular/core';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { MatSort } from '@angular/material/sort';
import { TylerMatTableDataSource } from '../../../../shared-components/angular-material/extended.class';
import { detailExpand } from '../../../../shared-components/angular-material/mat-animations';
import { AddMyReportFolderDialogComponent } from '../add-my-report-folder-dialog/add-my-report-folder-dialog.component';
import { MyReportsFolder, ReportsInFolder } from '../../reporting-framework.model';
import * as _ from 'lodash';
import { GeneralConfirmationComponent } from '../../../../shared-components/controls/general-confirmation/general-confirmation.component';
import { take } from 'rxjs/operators';
import { ReportingFrameworkService } from '../../reporting-framework.service';
import { FoldersThisReportDialogComponent } from '../folders-this-report-dialog/folders-this-report-dialog.component';
import { ManageReportsInFolderComponent } from '../manage-reports-in-folder/manage-reports-in-folder.component';
import { ManualEntryRostersComponent } from '../../../../shared-modules/reporting/V9/manual-entry-rosters/manual-entry-rosters.component';
import { ClassListAllComponent } from '../../../../shared-modules/reporting/V9/class-list-all/class-list-all.component';
import { ClassListAllAttendanceNotMarkedComponent } from '../../../../shared-modules/reporting/V9/class-list-all-attendance-not-marked/class-list-all-attendance-not-marked.component';
import { TeacherSummaryPreviewComponent } from '../../../../shared-modules/reporting/V9/teacher-summary-preview/teacher-summary-preview.component';
import { AttendanceHistoryByClassComponent } from '../../../../shared-modules/reporting/V9/attendance-history-by-class/attendance-history-by-class.component';
import { GradebookAssignmentsByStandardComponent } from '../../../../shared-modules/reporting/V9/gradebook-assignments-by-standard/gradebook-assignments-by-standard.component';
import { V9ReportParametersComponent } from '../../../../shared-modules/reporting/V9/parameters/v9-report-parameters.component';

@Component({
  selector: 'my-reports-tab',
  templateUrl: './my-reports-tab.component.html',
  styleUrls: ['./my-reports-tab.component.css'],
  animations: [detailExpand]
})
export class MyReportsTabComponent implements OnInit, OnChanges {

  tylerMatData = new TylerMatTableDataSource();
  isExpandAll = false;
  columnDisplay = ['More', 'FolderName', 'FolderDescription', 'Actions'];
  reportAreaColumns = ['ReportName', 'Actions'];

  @Input() myReportsFolders: MyReportsFolder[] = [];
  @Output() myReportFolderSaveEvent = new EventEmitter();


  @ViewChild(MatSort) set sort(val: MatSort) {
    if (this.tylerMatData) {
      this.tylerMatData.sort = val;
    }
  }

  manualEntryRostersDialogRef: MatDialogRef<ManualEntryRostersComponent>;
  classListAllDialogRef: MatDialogRef<ClassListAllComponent>;
  classListAllAttendanceNotMarkedDialogRef: MatDialogRef<ClassListAllAttendanceNotMarkedComponent>;
  teacherSummaryPreviewDialogRef: MatDialogRef<TeacherSummaryPreviewComponent>;
  attendanceHistoryByClassDialogRef: MatDialogRef<AttendanceHistoryByClassComponent>;
  gradebookAssignmentsByStandardDialogRef: MatDialogRef<GradebookAssignmentsByStandardComponent>; // ONE-4254

  constructor(
    private dialog: MatDialog,
    private dialogRef: MatDialogRef<GeneralConfirmationComponent>,
    private reportingFrameworkService: ReportingFrameworkService,
    private manualEntryRostersDialog: MatDialog,
    private classListAllDialog: MatDialog,
    private classListAllAttendanceNotMarkedDialog: MatDialog,
    private teacherSummaryPreviewDialog: MatDialog,
    private attendanceHistoryByClassDialog: MatDialog,
    private gradebookAssignmentsByStandardDialog: MatDialog, // ONE-4254
  ) { }

  ngOnInit() {
    this.tylerMatData = new TylerMatTableDataSource(this.myReportsFolders);
    this.tylerMatData.sort = this.sort;
  }

  ngOnChanges() {
    this.tylerMatData = new TylerMatTableDataSource(this.myReportsFolders);
    this.tylerMatData.sort = this.sort;
  }

  editFolder(mrf: MyReportsFolder) {
    const dialogBox = this.dialog.open(AddMyReportFolderDialogComponent, {
      width: '35vw',
      disableClose: true
    });
    dialogBox.componentInstance.dialogTitle = 'Edit Folder';
    dialogBox.componentInstance.editMode = true;
    dialogBox.componentInstance.myReportFolder = _.cloneDeep(mrf);
    dialogBox.afterClosed().subscribe(result => {
      if (result == 'save') {
        this.myReportFolderSaveEvent.emit();
      }
    });
  }

  deleteFolder(mrf: MyReportsFolder) {
    const deleteConfirmDialog = this.dialog.open(GeneralConfirmationComponent, {
      panelClass: 'tyl-mat-dialog',
      disableClose: true,
    });
    deleteConfirmDialog.componentInstance.headerLabel = 'Delete Folder';
    deleteConfirmDialog.componentInstance.confirmMessage = 'Are you sure you want to delete the ' + mrf.FolderName + ' folder?';
    deleteConfirmDialog.componentInstance.okButtonLabel = 'Delete';
    deleteConfirmDialog.componentInstance.confirmEvent.pipe(take(1)).subscribe((deleteObject: boolean) => {
      if (deleteObject) {
        this.reportingFrameworkService.deleteMyReportFolder(mrf.Id).pipe(take(1)).subscribe(result => {
          if (result == true) {
            this.myReportFolderSaveEvent.emit();
            this.dialogRef.close('save');
          }
        });
      }
    });
  }

  manageReports(mrf: MyReportsFolder) {
    const dialogBox = this.dialog.open(ManageReportsInFolderComponent, {
      height: '85vh',
      width: '40vw',
      disableClose: true
    });
    dialogBox.componentInstance.isMyReportPage = true;
    dialogBox.componentInstance.reportFolder = _.cloneDeep(mrf);
    dialogBox.afterClosed().pipe(take(1)).subscribe(result => {
      if (result == 'save') {
        this.myReportFolderSaveEvent.emit();
      }
    });
  }

  reportClick(rpt: ReportsInFolder) {
    if (rpt.ReportName == 'ManualEntryRosters') {
      this.manualEntryRostersDialogRef = this.manualEntryRostersDialog.open(ManualEntryRostersComponent, {
        panelClass: 'tyl-mat-dialog',
        disableClose: true,
        data: { Report: rpt },
        minWidth: '85vw',
        maxWidth: '100vw',
        minHeight: '85vh',
        maxHeight: '100vh'
      });
    }
    else if (rpt.ReportName == 'CreateCurrentDayAttendanceByClass' && rpt.ReportTitle == 'Class List - All') {
      this.classListAllDialogRef = this.classListAllDialog.open(ClassListAllComponent, {
        panelClass: 'tyl-mat-dialog',
        disableClose: true,
        data: { Report: rpt },
        minWidth: '85vw',
        maxWidth: '100vw',
        minHeight: '85vh',
        maxHeight: '100vh'
      });
    }
    else if (rpt.ReportName == 'CreateCurrentDayAttendanceByClass' && rpt.ReportTitle == 'Class List - Attendance Not Marked') {
      this.classListAllAttendanceNotMarkedDialogRef = this.classListAllAttendanceNotMarkedDialog.open(ClassListAllAttendanceNotMarkedComponent, {
        panelClass: 'tyl-mat-dialog',
        disableClose: true,
        data: { Report: rpt },
        minWidth: '85vw',
        maxWidth: '100vw',
        minHeight: '85vh',
        maxHeight: '100vh'
      });
    }
    else if (rpt.ReportName == 'AttendancePreviewByTeacher') {
      this.teacherSummaryPreviewDialogRef = this.teacherSummaryPreviewDialog.open(TeacherSummaryPreviewComponent, {
        panelClass: 'tyl-mat-dialog',
        disableClose: true,
        data: { Report: rpt },
        minWidth: '85vw',
        maxWidth: '100vw',
        minHeight: '85vh',
        maxHeight: '100vh'
      });
    }
    else if (rpt.ReportName == 'CreateAttendanceHistoryByClass' || rpt.Description == 'Attendance History by Class') {
      this.attendanceHistoryByClassDialogRef = this.attendanceHistoryByClassDialog.open(AttendanceHistoryByClassComponent, {
        panelClass: 'tyl-mat-dialog',
        disableClose: true,
        data: { Report: rpt },
        minWidth: '85vw',
        maxWidth: '100vw',
        minHeight: '85vh',
        maxHeight: '100vh'
      });
    }
    // else if (rpt.ReportName == 'GradeCommentList') {

    //   /*

    //   Public Class pub_clsReportCardCommentParameters
    //       'Connection String
    //       Public strConnectionString As String = ""
    //       'Report Parameters
    //       Public strReportOutputFile As String = ""
    //       Public strReportOutputFolderUNC As String = ""
    //       'Option Based Parameters
    //       Public strReportDate As String = ""
    //       Public strReportSiteHeader As String = ""
    //       Public strReportTitle As String = ""
    //       Public strSiteYearCode As String = ""
    //       Public intSiteYearId As Integer = 0
    //       Public strStudentSelectionStatus As String = ""
    //       Public strStudentIds As String = ""
    //       Public blnPageBreakAfterEachStudent As Boolean = False
    //   End Class
    //   */

    //   const reportType = 1;
    //   const reportTitle = 'Report Card Comment List';
    //   const reportName = 'GradeCommentList'; // 'CreateReportCardCommentsReport'; // 'GradeCommentList';

    //   const param = [];
    /* eslint-disable ,  */
    //   this.reportingService.addCoreParametersV9
    //     (
    //       param,
    //       reportTitle,
    //       reportType,
    //       // this.v9parameterName.strReportSiteAddress |
    //       this.v9parameterName.strReportDate |
    //       this.v9parameterName.strReportSiteHeader |
    //       this.v9parameterName.strReportTitle |
    //       this.v9parameterName.strSiteYearCode |
    //       this.v9parameterName.lngSiteYearId
    //       // this.v9parameterName.intSiteYearId |
    //       // this.v9parameterName.strOutputFile_NOFILE
    //       // this.v9parameterName.bytReportType ||
    //       // this.v9parameterName.strOutputFile_NOFILE

    //     );
    /* eslint-enable */

    //   // Public strStudentSelectionStatus As String = ""
    //   // Public strStudentIds As String = ""
    //   // Public blnPageBreakAfterEachStudent As Boolean = False

    //   const parameters = [];
    //   const stringifiedParameters = JSON.stringify(param);
    //   parameters.push(stringifiedParameters);

    //   if (this.reportingService.inDebugMode) {
    //     console.log('REPORT PARAMETERS TO BE RUN:');
    //     console.log(param);
    //     console.log('REPORT PARAMETERS STRINGIFIED:');
    //     console.log(stringifiedParameters);
    //   }

    //   this.reportingService.openStudentAttachmentReport(0, reportName, '', '', '', parameters, reportType);

    // }
    else if (rpt.ReportName == 'CreateGradebookAssignmentsByObjectiveReport') {
      this.gradebookAssignmentsByStandardDialogRef = this.gradebookAssignmentsByStandardDialog.open(GradebookAssignmentsByStandardComponent, {
        panelClass: 'tyl-mat-dialog',
        disableClose: true,
        data: { Report: rpt },
        minWidth: '85vw',
        maxWidth: '100vw',
        minHeight: '85vh',
        maxHeight: '100vh'
      });
    }
    else {
      const v9ReportParametersDialogRef = this.dialog.open(V9ReportParametersComponent, {
        panelClass: 'tyl-mat-dialog',
        disableClose: true,
        data: { Report: rpt },
        minWidth: '50vw',
        maxWidth: '100vw',
        minHeight: '50vh',
        maxHeight: '100vh'
      });

      v9ReportParametersDialogRef.componentInstance.selectedReport = JSON.parse(JSON.stringify(rpt));

      v9ReportParametersDialogRef.afterClosed().subscribe(result => {
        if (result != undefined) {
          // this.getMyV9Reports();
        }
      });
    }
  }


  folderforthisReportClick(rpt: ReportsInFolder, mrf: MyReportsFolder) {
    const thisReportDialog = this.dialog.open(FoldersThisReportDialogComponent, {
      height: '85vh',
      width: '40vw',
      disableClose: true
    });
    thisReportDialog.componentInstance.report = _.cloneDeep(rpt);
    thisReportDialog.componentInstance.reportFolders = _.cloneDeep(this.myReportsFolders);

    thisReportDialog.afterClosed().pipe(take(1)).subscribe(result => {
      if (result == 'save') {
        this.myReportFolderSaveEvent.emit();
      }
    });
  }

  deleteReportClick(rpt: ReportsInFolder, mrf: MyReportsFolder) {
    const deleteConfirmDialog = this.dialog.open(GeneralConfirmationComponent, {
      panelClass: 'tyl-mat-dialog',
      disableClose: true,
    });
    deleteConfirmDialog.componentInstance.headerLabel = 'Remove';
    deleteConfirmDialog.componentInstance.confirmMessage = 'Are you sure you want to remove the ' + rpt.Description + ' report from <br/>the folder ' + mrf.FolderName + '?';
    deleteConfirmDialog.componentInstance.okButtonLabel = 'Remove';
    deleteConfirmDialog.componentInstance.confirmEvent.pipe(take(1)).subscribe((deleteObject: boolean) => {
      if (deleteObject) {
        this.reportingFrameworkService.deleteReportInFolder(rpt.ReportFolderId, rpt.ReportId).pipe(take(1)).subscribe(result => {
          if (result == true) {
            const reportFolder = this.myReportsFolders.find(x => x.Id == mrf.Id);
            const idx = reportFolder.ReportsInFolder.indexOf(rpt);
            reportFolder.ReportsInFolder.splice(idx, 1);
            this.tylerMatData.data = [];
            this.tylerMatData = new TylerMatTableDataSource(this.myReportsFolders);
            this.tylerMatData.sort = this.sort;
          }
        });
      }
    });
  }

  expandAll() {
    this.isExpandAll = !this.isExpandAll;
    for (const row of this.tylerMatData.data) {
      row.detailRow = this.isExpandAll;
    }
  }

  checkExpanded(row: any): boolean {
    return this.tylerMatData.checkExpanded(row);
  }

  toggleExpanded(row: any) {
    this.tylerMatData.toggleExpanded(row);
  }

  rowKeyPress(event: KeyboardEvent, row: any) {
    this.tylerMatData.rowKeyPress(event, row);
  }

}
